export default __webpack_public_path__ + "static/Effra-He-e1dd750f5e99cf5077e7c04582234156.ttf";